import { ItDropdownBase } from './it-dropdown-base.js';
import '../index-B6UWwXKd.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/if-defined.js';

/**
 * @element it-dropdown
 */
class ItDropdown extends ItDropdownBase {
}
if (!customElements.get('it-dropdown')) {
    customElements.define('it-dropdown', ItDropdown);
}

export { ItDropdown };
//# sourceMappingURL=it-dropdown.js.map
